document.addEventListener('DOMContentLoaded', function () {

    // Make sure $ refers to jQuery in WP noConflict mode
    var $ = window.jQuery || window.$;

    /**
     * Move the manual shipping address toggle below Address Finder.
     */
    function positionShippingAddressToggle() {
        var $address = $('#shipping_address_1_field');
        var $toggle = $('#toggle-shipping-address').closest('.ld-manual-address-toggle-row');

        if ($address.length && $toggle.length) {
            $toggle.insertAfter($address);
        }
    }

    // --- Cache the key DOM nodes we interact with throughout checkout ---
    var checkbox = document.getElementById('billing-to-same-address-checkbox');
    var billingFields = document.querySelector('.checkout-details__billing-fields');
    var errorBox = document.getElementById('shipping-error-message');

    // --- Simple helpers available everywhere ---

    function hideBillingFields() {

        var billingFieldDivs = document.querySelectorAll(
            '.checkout-details__billing-fields .checkout-details__field, .checkout-details__billing-fields .woocommerce-billing-fields__heading, .checkout-details__billing-fields #thwma-billing-alt_field, .checkout-details__address-toggle--billing'
        );

        billingFieldDivs.forEach(function (el) {
            el.style.display = 'none';
        });
    }

    // this will only show the heading, email, first and last name, company name, and address finder (we will have an additional function to show the rest when the user clicks enter address manually)
    function showBillingFields() {

        var billingFieldDivs = document.querySelectorAll(
            '.checkout-details__billing-fields .checkout-details__field#billing_email_field, .checkout-details__billing-fields .checkout-details__field#billing_first_name_field, .checkout-details__billing-fields .checkout-details__field#billing_last_name_field, .checkout-details__billing-fields .checkout-details__field#billing_company_field, .checkout-details__billing-fields .checkout-details__field#billing_address_1_field, .checkout-details__billing-fields .woocommerce-billing-fields__heading, .checkout-details__billing-fields #thwma-billing-alt_field, .checkout-details__address-toggle--billing, .checkout-details__billing-fields .checkout-details__field#billing_phone_field'
        );

        billingFieldDivs.forEach(function (el) {
            el.style.display = '';
        });
    }

    function showAllBillingFields() {

        var allBillingFieldDivs = document.querySelectorAll(
            '.checkout-details__billing-fields .checkout-details__field#billing_address_2_field, .checkout-details__billing-fields .checkout-details__field#billing_city_field, .checkout-details__billing-fields .checkout-details__field#billing_state_field, .checkout-details__billing-fields .checkout-details__field#billing_postcode_field,.checkout-details__billing-fields .checkout-details__field#billing_country_field'
        );

        var autocompleteFields = document.querySelectorAll('.pcaautocomplete');
        var enterManually = document.querySelector('.checkout-details__address-toggle--billing');
        var billingAddress1Label = document.querySelector('label[for="billing_address_1"]');

        if (billingAddress1Label && billingAddress1Label.childNodes.length) {
            billingAddress1Label.childNodes[0].nodeValue = 'Address Line 1';
        }

        if (enterManually) {
            enterManually.style.display = 'none';
        }

        allBillingFieldDivs.forEach(function (el) {
            el.style.display = '';
        });

        autocompleteFields.forEach(function (el, index) {
            if (index === 0) {
                el.classList.add('hidden');
            }
        });
    }

    function hideShippingFields() {

        var shippingFieldDivs = document.querySelectorAll(
            '.checkout-details__shipping-fields .checkout-details__field#shipping_address_2_field, .checkout-details__shipping-fields .checkout-details__field#shipping_city_field, .checkout-details__shipping-fields .checkout-details__field#shipping_state_field, .checkout-details__shipping-fields .checkout-details__field#shipping_postcode_field, .checkout-details__shipping-fields .checkout-details__field#shipping_country_field'
        );

        shippingFieldDivs.forEach(function (el) {
            el.style.display = 'none';
        });
    }

    function showShippingFields() {

        var shippingFieldDivs = document.querySelectorAll(
            '.checkout-details__shipping-fields .checkout-details__field#shipping_address_2_field, .checkout-details__shipping-fields .checkout-details__field#shipping_city_field, .checkout-details__shipping-fields .checkout-details__field#shipping_state_field, .checkout-details__shipping-fields .checkout-details__field#shipping_postcode_field, .checkout-details__shipping-fields .checkout-details__field#shipping_country_field'
        );

        var autocompleteFields = document.querySelectorAll('.pcaautocomplete');
        var enterManually = document.querySelector('.checkout-details__address-toggle--shipping');
        var shippingAddress1Label = document.querySelector('label[for="shipping_address_1"]');

        if (shippingAddress1Label && shippingAddress1Label.childNodes.length) {
            shippingAddress1Label.childNodes[0].nodeValue = 'Address Line 1';
        }

        if (enterManually) {
            enterManually.style.display = 'none';
        }

        shippingFieldDivs.forEach(function (el) {
            el.style.display = '';
        });

        autocompleteFields.forEach(function (el, index) {
            if (index === 2) {
                el.classList.add('hidden');
            }
        });
    }

    function untickBillingSameAddress() {

        if (checkbox && checkbox.checked) {

            checkbox.checked = false;

            try {
                checkbox.dispatchEvent(new Event('change', {
                    bubbles: true
                }));
            } catch (e) {
                var evt = document.createEvent('HTMLEvents');

                evt.initEvent('change', true, false);
                checkbox.dispatchEvent(evt);
            }
        }
    }

    // --- Shipping fields that must be present for a valid checkout ---

    var requiredFields = [
        'shipping_first_name',
        'shipping_last_name',
        'shipping_address_1',
        'shipping_city',
        'shipping_postcode',
        'shipping_phone',
        'shipping_email'
    ];

    var liveValidationStarted = false;

    // --- Copies shipping values into corresponding billing fields ---

    function syncShippingToBilling() {

        var fields = [
            'first_name',
            'last_name',
            'company',
            'address_1',
            'address_2',
            'city',
            'state',
            'postcode',
            'phone',
            'email'
        ];

        fields.forEach(function (field) {

            var shipping = document.querySelector('#shipping_' + field);
            var billing = document.querySelector('#billing_' + field);

            if (shipping && billing) {
                billing.value = shipping.value;
            }
        });
    }

    // --- Minimal client-side validator for shipping fields ---

    function validateShippingFields() {

        var allValid = true;
        var missingLabels = [];

        requiredFields.forEach(function (fieldId) {

            var field = document.getElementById(fieldId);

            if (field) {

                field.classList.remove('checkout-details__field-error');

                if (!field.value.trim()) {

                    field.classList.add('checkout-details__field-error');

                    var label = document.querySelector(
                        'label[for="' + fieldId + '"]'
                    );

                    if (label) {
                        missingLabels.push(label.textContent.trim());
                    }

                    allValid = false;
                }
            }
        });

        if (!allValid && errorBox) {

            errorBox.style.display = 'block';

            errorBox.innerHTML =
                '<strong>Please complete the following required fields:</strong>' +
                '<ul><li>' +
                missingLabels.join('</li><li>') +
                '</li></ul>';

        } else if (errorBox) {

            errorBox.style.display = 'none';
            errorBox.innerHTML = '';
        }

        return allValid;
    }

    function startLiveValidation() {

        if (liveValidationStarted) {
            return;
        }

        liveValidationStarted = true;

        requiredFields.forEach(function (fieldId) {

            var field = document.getElementById(fieldId);

            if (field) {
                field.addEventListener('input', function () {
                    validateShippingFields();
                });
            }
        });
    }

    // --- Billing field behaviour ---

    if (checkbox && billingFields) {

        function setInitialUIOnly() {

            setTimeout(function () {

                hideShippingFields();

                if (checkbox.checked) {

                    hideBillingFields();
                    syncShippingToBilling();

                } else {

                    showBillingFields();
                }

                if (errorBox) {
                    errorBox.style.display = 'none';
                    errorBox.innerHTML = '';
                }

                if (
                    document.querySelector(
                        '.delivery-buttons__button--collect.delivery-buttons__button--checked'
                    )
                ) {
                    untickBillingSameAddress();
                }

            }, 200);
        }

        function handleCheckboxChange() {

            setTimeout(function () {

                if (checkbox.checked) {

                    syncShippingToBilling();
                    hideBillingFields();

                    if (errorBox) {
                        errorBox.style.display = 'none';
                        errorBox.innerHTML = '';
                    }

                } else {

                    showBillingFields();
                }

            }, 200);
        }

        setInitialUIOnly();
        positionShippingAddressToggle();

        checkbox.addEventListener(
            'change',
            handleCheckboxChange
        );

    } else {

        showBillingFields();
    }

    // --- Validate shipping on form submit ---

    var form = document.querySelector('#checkout_form');

    if (form) {

        form.addEventListener('submit', function (e) {

            if (!validateShippingFields()) {

                e.preventDefault();
                startLiveValidation();
            }
        });
    }

    /*
     * Final safeguard.
     *
     * Silently copy shipping values into billing immediately before
     * checkout submission.
     *
     * IMPORTANT:
     * Do not trigger input/change events here.
     *
     * WooCommerce may interpret those events as a reason to run
     * update_checkout. Doing that at the same time as Place Order
     * can result in checkout fragments and delivery/collection
     * state being refreshed while the order is being submitted.
     */

// --- Final safeguard: sync shipping → billing before submission if opted-in ---
(function () {

    var checkbox = document.getElementById('billing-to-same-address-checkbox');

    var form = document.querySelector('form.checkout') ||
        document.querySelector('#checkout') ||
        document.querySelector('form[name="checkout"]');

    var fields = [
        'first_name',
        'last_name',
        'company',
        'address_1',
        'address_2',
        'city',
        'state',
        'postcode',
        'phone',
        'email'
    ];

    /**
     * Copy shipping values to billing without triggering checkout updates.
     */
    function syncShippingToBillingBeforeSubmit() {

        if (!checkbox || !checkbox.checked) {
            return;
        }

        fields.forEach(function (field) {

            var shipping = document.querySelector('#shipping_' + field);
            var billing = document.querySelector('#billing_' + field);

            if (shipping && billing) {
                billing.value = shipping.value;
            }
        });
    }

    if (form) {
        form.addEventListener('submit', function () {
            syncShippingToBillingBeforeSubmit();
        });
    }

})();

    // ===== Click & Collect =====

    function loadClickAndCollectLocations() {

        // var clickAndCollectSelect =
        //     $('input[data-pickup-object-id], select[data-pickup-object-id]');

            var clickAndCollectSelect = $('.pickup-location-lookup[data-pickup-object-id]');

        var optionsElement =
            $('#click-and-collect-options');

        if (clickAndCollectSelect.length === 0) {

            $('#place_order').prop(
                'disabled',
                true
            );

            if (
                $('#click-and-collect-form').length !== 0
            ) {

                $('#click-and-collect-form').empty();

                $('#place_order').prop(
                    'disabled',
                    false
                );
            }

            return;
        }

        $.post(
            LD.ajax_url,
            {
                action: 'click_and_collect',
                security: LD.nonce
            },
            function (response) {

                if (
                    response.success &&
                    response.data
                ) {

                    if (optionsElement.length === 0) {

                        $('#place_order').prop(
                            'disabled',
                            false
                        );

                        $('#click-and-collect-form').append(
                            response.data
                        );
                    }

                    var selectedRadio =
                        $('#click-and-collect-form input[name="click_collect"]:checked');

                    if (selectedRadio.length > 0) {

                        var available =
                            selectedRadio.data('available');

                        if (available) {

                            $('#place_order').prop(
                                'disabled',
                                false
                            );

                        } else {

                            $('#place_order').prop(
                                'disabled',
                                true
                            );
                        }

                        var defaultValue =
                            selectedRadio.val();

                        if (clickAndCollectSelect.length && defaultValue) {

                            var defaultLabel =
                                selectedRadio.closest('label').text().trim() ||
                                selectedRadio.data('name') ||
                                defaultValue;

                            setPickupLocation(
                                defaultValue,
                                defaultLabel,
                                false
                            );
                        }
                    }

                    /*
                     * Remove our previous handler before binding it again.
                     *
                     * loadClickAndCollectLocations() runs after every
                     * updated_checkout, so without .off() the click
                     * handler can be added repeatedly.
                     */

                    $('#click-and-collect-form')
                        .off(
                            'click.clickCollect',
                            'input[name="click_collect"]'
                        )
                        .on(
                            'click.clickCollect',
                            'input[name="click_collect"]',
                            function () {

                                var radioValue =
                                    $(this).val();

                                var available =
                                    $(this).data('available');

                                if (radioValue) {

                                    var radioLabel =
                                        $(this).closest('label').text().trim() ||
                                        $(this).data('name') ||
                                        radioValue;

                                    setPickupLocation(
                                        radioValue,
                                        radioLabel,
                                        true
                                    );
                                }

                                if (available) {

                                    $('#place_order').prop(
                                        'disabled',
                                        false
                                    );

                                } else {

                                    $('#place_order').prop(
                                        'disabled',
                                        true
                                    );
                                }
                            }
                        );
                }
            }
        );

        /**
 * Set the Local Pickup Plus location fields.
 */
function setPickupLocation(value, label, triggerChange) {

    clickAndCollectSelect.each(function () {

        var $field = $(this);

        if ($field.is('select')) {

            var optionExists = $field.find('option').filter(function () {
                return String($(this).val()) === String(value);
            }).length > 0;

            if (!optionExists) {

                $field.append(
                    $('<option>', {
                        value: value,
                        text: label
                    })
                );
            }
        }

        $field.val(value);

        if (triggerChange) {
            $field.trigger('change');
        }
    });
}
    }

    // --- Shipping address manual/retrieved address behaviour ---

    $(document).on(
        'click',
        '#toggle-shipping-address, .pcaselected',
        function (e) {

            var autocompleteFields =
                document.querySelectorAll(
                    '.pcaautocomplete'
                );

            var shippingAutocomplete =
                autocompleteFields[2];

            var shouldShowFields = false;

            if (
                $(this).is(
                    '#toggle-shipping-address'
                )
            ) {

                e.preventDefault();

                $(this)
                    .closest(
                        '.ld-manual-address-toggle-row'
                    )
                    .hide();

                shouldShowFields = true;

            } else if (
                shippingAutocomplete &&
                shippingAutocomplete.contains(this)
            ) {

                var descriptionText =
                    $(this)
                        .find('.pcadescription')
                        .text()
                        .toLowerCase();

                if (
                    descriptionText.indexOf(
                        'addresses'
                    ) === -1
                ) {
                    shouldShowFields = true;
                }
            }

            if (shouldShowFields) {

                setTimeout(function () {
                    showShippingFields();
                }, 100);
            }
        }
    );

    // --- Billing address manual/retrieved address behaviour ---

    $(document).on(
        'click',
        '#toggle-billing-address, .pcaselected',
        function (e) {

            var autocompleteFields =
                document.querySelectorAll(
                    '.pcaautocomplete'
                );

            var billingAutocomplete =
                autocompleteFields[0];

            var shouldShowFields = false;

            if (
                $(this).is(
                    '#toggle-billing-address'
                )
            ) {

                e.preventDefault();

                $(this)
                    .closest(
                        '.ld-manual-address-toggle-row'
                    )
                    .hide();

                shouldShowFields = true;

            } else if (
                billingAutocomplete &&
                billingAutocomplete.contains(this)
            ) {

                var descriptionText =
                    $(this)
                        .find('.pcadescription')
                        .text()
                        .toLowerCase();

                if (
                    descriptionText.indexOf(
                        'addresses'
                    ) === -1
                ) {
                    shouldShowFields = true;
                }
            }

            if (shouldShowFields) {

                setTimeout(function () {
                    showAllBillingFields();
                }, 100);
            }
        }
    );

    // --- Show address fields after address lookup AJAX ---

    $(document).ajaxComplete(
        function (event, xhr, settings) {

            var data = settings.data || '';
            var action = '';

            if (typeof data === 'string') {

                var params =
                    new URLSearchParams(data);

                action =
                    params.get('action');

            } else if (
                typeof data === 'object' &&
                data !== null
            ) {

                action = data.action;
            }

            if (
                action === 'get_address_with_id'
            ) {

                setTimeout(function () {

                    showShippingFields();

                    if (
                        checkbox &&
                        !checkbox.checked
                    ) {
                        showAllBillingFields();
                    }

                }, 100);
            }
        }
    );

    // --- Reload collection locations after WooCommerce refreshes checkout ---

    $(document.body).on(
        'updated_checkout',
        function () {
            loadClickAndCollectLocations();
            positionShippingAddressToggle();
        }
    );

    /*
     * Delivery / collection buttons.
     *
     * Use delegated events because WooCommerce may replace this
     * markup during update_checkout.
     *
     * Directly binding to the buttons present on initial page load
     * means the replacement buttons would no longer have a handler.
     */

    $(document)
        .off(
            'click.deliveryType',
            '.delivery-buttons__button'
        )
        .on(
            'click.deliveryType',
            '.delivery-buttons__button',
            function () {

                var $button = $(this);

                $button.addClass(
                    'delivery-buttons__button--checked'
                );

                $('.delivery-buttons__button')
                    .not(this)
                    .removeClass(
                        'delivery-buttons__button--checked'
                    );

                if (
                    $button.hasClass(
                        'delivery-buttons__button--collect'
                    )
                ) {

                    setTimeout(function () {

                        if (
                            $button.hasClass(
                                'delivery-buttons__button--checked'
                            )
                        ) {
                            untickBillingSameAddress();
                        }

                    }, 50);
                }
            }
        );

});